import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import useAuth from '../hooks/useAuth';
import usePolling from '../hooks/usePolling';
import ConversaItem from '../components/ConversaItem';

function iniciais(nome) {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export default function Fila() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [conversas, setConversas] = useState([]);

  const fetchConversas = useCallback(async () => {
    try {
      const { data } = await api.get('/conversas');
      setConversas(data.data ?? []);
    } catch {}
  }, []);

  usePolling(fetchConversas, 5000);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const pendentes = conversas.filter(c => c.status === 'pendente').length;
  const urgencias = conversas.filter(c => c.status === 'urgente').length;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA', fontFamily: 'Inter, -apple-system, sans-serif' }}>
      <div style={{
        height: '56px',
        backgroundColor: '#FFFFFF',
        borderBottom: '0.5px solid #E9ECEF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '34px',
            height: '34px',
            borderRadius: '50%',
            backgroundColor: '#E6F1FB',
            color: '#185FA5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: 600,
            flexShrink: 0,
          }}>
            {iniciais(usuario?.nome)}
          </div>
          <div>
            <p style={{ margin: 0, fontSize: '13px', fontWeight: 500, color: '#1A1A2E' }}>
              {usuario?.nome}
            </p>
            <p style={{ margin: 0, fontSize: '11px', color: '#6C757D' }}>Recepcionista</p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{
            backgroundColor: '#E1F5EE',
            color: '#0F6E56',
            borderRadius: '99px',
            fontSize: '11px',
            fontWeight: 500,
            padding: '2px 8px',
          }}>
            Online
          </span>
          <button
            onClick={handleLogout}
            style={{
              padding: '4px 10px',
              backgroundColor: '#F1F3F5',
              color: '#6C757D',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Sair
          </button>
        </div>
      </div>

      <div style={{ padding: '16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
          {[
            { label: 'Fila hoje', value: conversas.length, color: '#1A1A2E' },
            { label: 'Pendentes', value: pendentes, color: '#854F0B' },
            { label: 'Urgências', value: urgencias, color: '#991B1B' },
          ].map(({ label, value, color }) => (
            <div key={label} style={{
              backgroundColor: '#F1F3F5',
              borderRadius: '8px',
              padding: '12px 14px',
            }}>
              <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#6C757D' }}>{label}</p>
              <p style={{ margin: 0, fontSize: '22px', fontWeight: 500, color }}>{value}</p>
            </div>
          ))}
        </div>

        <p style={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#6C757D',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          margin: '0 0 8px',
        }}>
          Conversas da minha fila
        </p>

        {conversas.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '32px 16px',
            color: '#ADB5BD',
            fontSize: '14px',
            border: '0.5px solid #E9ECEF',
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
          }}>
            Nenhuma conversa na fila
          </div>
        ) : (
          <div style={{
            border: '0.5px solid #E9ECEF',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: '#FFFFFF',
          }}>
            {conversas.map((c, i) => (
              <div
                key={c.id}
                style={{ borderBottom: i < conversas.length - 1 ? '0.5px solid #E9ECEF' : 'none' }}
              >
                <ConversaItem
                  conversa={c}
                  onClick={() => navigate(`/conversa/${c.id}`)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
